import { toggle } from '@/utils/vuex'
import AlertType from '@/utils/alertType';

export default {
    showAlert: (state, messages) => {          
        state.messages = typeof(messages) === "string" ? [messages] : messages;   
        state.type = AlertType.ALERTA;
        state.show = true;
        setTimeout(() => state.show = false, 7000);
    },
    showAlertSuccess: (state, messages) => {          
        state.messages = typeof(messages) === "string" ? [messages] : messages;   
        state.type = AlertType.SUCESSO;
        state.show = true;
        setTimeout(() => state.show = false, 7000);        
    },
    toggleAlert: toggle('show'),
}